//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IRelevanceRulesClient {
    /**
     * Obtener reglas de relevancia por tienda
     * @return Configuración activa encontrada
     */
    get(storeId: string): Observable<RelevanceRuleDto>;
    /**
     * Crear o actualizar regla de relevancia (Upsert)
     * @return Regla actualizada/creada exitosamente
     */
    upsert(storeId: string, body: UpsertRelevanceRuleDto): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RelevanceRulesClient implements IRelevanceRulesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Obtener reglas de relevancia por tienda
     * @return Configuración activa encontrada
     */
    get(storeId: string): Observable<RelevanceRuleDto> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/relevance";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelevanceRuleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelevanceRuleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RelevanceRuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelevanceRuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No se encontr\u00f3 una regla para esta marca", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crear o actualizar regla de relevancia (Upsert)
     * @return Regla actualizada/creada exitosamente
     */
    upsert(storeId: string, body: UpsertRelevanceRuleDto): Observable<void> {
        let url_ = this.baseUrl + "/hub/stores/{storeId}/rules/relevance";
        if (storeId === undefined || storeId === null)
            throw new globalThis.Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token inv\u00e1lido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class RelevanceRuleDto implements IRelevanceRuleDto {
    /** Identificador único de la regla (o UUID generado) */
    id!: string;
    /** Configuración activa de la regla */
    configuration!: RelevanceRuleConfigurationDto;

    [key: string]: any;

    constructor(data?: IRelevanceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.configuration = new RelevanceRuleConfigurationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.configuration = _data["configuration"] ? RelevanceRuleConfigurationDto.fromJS(_data["configuration"]) : new RelevanceRuleConfigurationDto();
        }
    }

    static fromJS(data: any): RelevanceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelevanceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        return data;
    }
}

export interface IRelevanceRuleDto {
    /** Identificador único de la regla (o UUID generado) */
    id: string;
    /** Configuración activa de la regla */
    configuration: RelevanceRuleConfigurationDto;

    [key: string]: any;
}

export class UpsertRelevanceRuleDto implements IUpsertRelevanceRuleDto {
    /** Objeto de configuración de pesos de relevancia */
    configuration!: RelevanceRuleConfigurationInputDto;

    [key: string]: any;

    constructor(data?: IUpsertRelevanceRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.configuration = new RelevanceRuleConfigurationInputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.configuration = _data["configuration"] ? RelevanceRuleConfigurationInputDto.fromJS(_data["configuration"]) : new RelevanceRuleConfigurationInputDto();
        }
    }

    static fromJS(data: any): UpsertRelevanceRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRelevanceRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["configuration"] = this.configuration ? this.configuration.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpsertRelevanceRuleDto {
    /** Objeto de configuración de pesos de relevancia */
    configuration: RelevanceRuleConfigurationInputDto;

    [key: string]: any;
}

export class RelevanceRuleConfigurationDto implements IRelevanceRuleConfigurationDto {
    /** Peso para el score general */
    score!: number;
    /** Peso para la fecha de lanzamiento */
    releaseDate!: number;
    /** Peso para los productos más vendidos */
    bestSelling!: number;
    /** Peso para la diferencia de descuento */
    discount_diff!: number;
    /** Peso para la popularidad */
    popularity!: number;

    [key: string]: any;

    constructor(data?: IRelevanceRuleConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.score = _data["score"];
            this.releaseDate = _data["releaseDate"];
            this.bestSelling = _data["bestSelling"];
            this.discount_diff = _data["discount_diff"];
            this.popularity = _data["popularity"];
        }
    }

    static fromJS(data: any): RelevanceRuleConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelevanceRuleConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["score"] = this.score;
        data["releaseDate"] = this.releaseDate;
        data["bestSelling"] = this.bestSelling;
        data["discount_diff"] = this.discount_diff;
        data["popularity"] = this.popularity;
        return data;
    }
}

export interface IRelevanceRuleConfigurationDto {
    /** Peso para el score general */
    score: number;
    /** Peso para la fecha de lanzamiento */
    releaseDate: number;
    /** Peso para los productos más vendidos */
    bestSelling: number;
    /** Peso para la diferencia de descuento */
    discount_diff: number;
    /** Peso para la popularidad */
    popularity: number;

    [key: string]: any;
}

export class RelevanceRuleConfigurationInputDto implements IRelevanceRuleConfigurationInputDto {
    /** Peso para el score general */
    score!: number;
    /** Peso para la fecha de lanzamiento */
    releaseDate!: number;
    /** Peso para los productos más vendidos */
    bestSelling!: number;
    /** Peso para la diferencia de descuento */
    discount_diff!: number;
    /** Peso para la popularidad */
    popularity!: number;

    [key: string]: any;

    constructor(data?: IRelevanceRuleConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.score = _data["score"];
            this.releaseDate = _data["releaseDate"];
            this.bestSelling = _data["bestSelling"];
            this.discount_diff = _data["discount_diff"];
            this.popularity = _data["popularity"];
        }
    }

    static fromJS(data: any): RelevanceRuleConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelevanceRuleConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["score"] = this.score;
        data["releaseDate"] = this.releaseDate;
        data["bestSelling"] = this.bestSelling;
        data["discount_diff"] = this.discount_diff;
        data["popularity"] = this.popularity;
        return data;
    }
}

export interface IRelevanceRuleConfigurationInputDto {
    /** Peso para el score general */
    score: number;
    /** Peso para la fecha de lanzamiento */
    releaseDate: number;
    /** Peso para los productos más vendidos */
    bestSelling: number;
    /** Peso para la diferencia de descuento */
    discount_diff: number;
    /** Peso para la popularidad */
    popularity: number;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}